import React, { Fragment, useEffect } from "react";

// import { Link } from "react-router-dom";
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import { useSelector, useDispatch } from "react-redux";
import swal from "sweetalert";
import Navbar from "../HomeScreen/Navbar";
import {
  clearErrorAction,
  getAllNotificationaActionByUser,
  readNotificationaActionByUser,
} from "../../redux/actions/notificationAction";

import './notification.css';
import Footer from "../HomeScreen/bottomsection/Footer";

const safeText = (value, fallback = "") => {
  if (value === null || value === undefined) return fallback;
  if (typeof value === "string" || typeof value === "number") return String(value);
  return fallback;
};

function NotificationMainPage() {
  const dispatch = useDispatch();

  const { error, notification } = useSelector(
    (state) => state.userNotification
  );
  const notifications = Array.isArray(notification) ? notification : [];

  useEffect(() => {
    if (error) {
      swal({
        title: "Notification Error",
        text: error,
        icon: "error",
      });
      dispatch(clearErrorAction());
    }

    dispatch(getAllNotificationaActionByUser());
  }, [dispatch, error]);



  const getClickHandler = (id) => {
    dispatch(readNotificationaActionByUser(id))
  }

  return (
    <Fragment>
      <Navbar />
      <div className="notification-page-style-main-div">
        <section className="notification-hero">
          <span>Updates</span>
          <h1>Notifications</h1>
          <p>Order updates, account alerts, and shopping messages stay here.</p>
        </section>

        <section className="notification-list-panel">
        {notifications.length === 0 ? (
          <Fragment>
            <div className='empty-div-main-notification-page-container'>
              <NotificationImportantIcon/>
              <span>No notifications yet</span>
              <p className='empty-div-main-notification-page-container-paragarph'>
                When there is an order update or account message, it will appear here.
              </p>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            {notifications.map((data) => {
              const displayTitle = data.title || (data.notifactionRead ? "Notice" : "New Update");
              const dateStr = data.createdAt ? new Date(data.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "";
              return (
                <div
                  key={data._id || safeText(data.message)}
                  className={data.notifactionRead === true ? 'notification-message-read' : 'notification-message-unread'}
                  onClick={() => getClickHandler(data._id)}
                  style={{ cursor: "pointer" }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "4px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span>{data.notifactionRead === true ? "Read" : "New"}</span>
                      {data.type && (
                        <span style={{ color: "#a85050", background: "#f5f6f4", padding: "2px 6px", borderRadius: "4px", fontSize: "11px", fontWeight: "700" }}>
                          {data.type.replace(/_/g, " ").toUpperCase()}
                        </span>
                      )}
                    </div>
                    {dateStr && <span style={{ color: "#8a94a6", fontSize: "12px", textTransform: "none", fontWeight: "600" }}>{dateStr}</span>}
                  </div>
                  <h4 style={{ margin: "2px 0 6px 0", fontSize: "15px", fontWeight: "800", color: "#111315" }}>{displayTitle}</h4>
                  <p>{safeText(data.message, "Notification update")}</p>
                  {data.actionLink && (
                    <a
                      href={data.actionLink}
                      style={{ display: "inline-block", marginTop: "8px", fontSize: "13px", fontWeight: "700", color: "#a85050", textDecoration: "none" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      View Details →
                    </a>
                  )}
                </div>
              );
            })}
          </Fragment>
        )}
        </section>

      </div>
      <Footer />
    </Fragment>
  );
}

export default NotificationMainPage;
